import React, { PropTypes } from 'react'
import styled from 'styled-components'
import { Metrics, Fonts, Colors } from '../../Themes'

const propTypes = {
  onClick: PropTypes.func,
  odd: PropTypes.bool,
  children: PropTypes.node
}

const ListItemContainer = styled.div`
  padding: ${Metrics.margins.small} 0;
  padding-left: ${Metrics.margins.small};
  ${Fonts.style.Text};

  &:hover {
    background: ${Colors.lightGrey};
    cursor: pointer;
  }

  svg {
    float: right;
  }
`

const ListItem = props => {
  const { children } = props
  return <ListItemContainer {...props}>{children}</ListItemContainer>
}

ListItem.propTypes = propTypes

export default ListItem



// WEBPACK FOOTER //
// ./src/components/ListItem/index.js